/**
 * The three views the Cashflow Forecast report's Committed / Uncommitted / Total
 * toggle can select. Total is the default.
 */
export const COMMITMENT_VIEWS = {
    TOTAL: 'total',
    COMMITTED: 'committed',
    UNCOMMITTED: 'uncommitted',
};
